<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="toolRequisitionBills"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="单号">
              <el-input v-model.trim="filter.billNo" placeholder="请输入编号" clearable/>
            </el-form-item>
            <el-form-item label="治具名称">
              <el-input v-model.trim="filter.toolName" placeholder="请输入名称" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </view-table>
    <tool-requisition-bill-edit ref="edit" @save-success="loadData"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import ToolRequisitionBillEdit from "@/views/information/ToolManagement/ToolRequisitionBill/ToolRequisitionBillEdit";

  export default {
    components: {ToolRequisitionBillEdit, ViewTable },
    data() {
      return {
        limits: {
          addAuth: this.$auth(472),
          editAuth: this.$auth(472),
          delAuth: this.$auth(472),
        },
        filter: {
          billNo: "",
          toolName: "",
        },
        columnsProperty: [
          {
            key: "billNo",
            align: "center",
            tooltip: true,
            width: 110,
          },
          {
            key: "toolName",
            align: "center",
            tooltip: true,
            width: 110,
          },
          {
            key: "receiverName",
            tooltip: true,
            minWidth: 110,
          },
          {
            key: "receiveTime",
            tooltip: true,
            width: 120,
            align: "center",
          },
          {
            key: "returnerName",
            tooltip: true,
            width: 120,
            align: "center",
          },
          {
            key: "returnTime",
            tooltip: true,
            width: 120,
            align: "center",
          },
          {
            key: "creatorName",
            width: 120,
            tooltip: true,
            align: "cnter",
          },
          {
            key: "createTime",
            tooltip: true,
            width: 120,
            align: "center",
          },
          {
            key: "status",
            width: 120,
            tooltip: true,
            align: "center",
          },
          {
            key: "note",
            width: 120,
            tooltip: true,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      addEditHandle(row) {
        this.$refs.edit.open(row);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "tools", row.pkid).then((resp) => {
          console.log(resp);
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
